<template>
  <div class="modal fade" id="modalSendUserLog" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">Notificação de Log.</h4>
        </div>

        <div class="modal-body">
          <p class="text-inf">
            O funcionário irá receber a notificação, mas o log só será enviado se o <strong>aplicativo estiver aberto ou
            em segundo plano</strong>, se o app tiver <strong>"morto"</strong> ele irá receber a notificação mas o
            <strong>log não será enviado</strong>
          </p>
          <form>
            <div class="form-group select-date">
              <label>Data</label>
              <datepicker v-model="dataLog.date" :language="ptBR" :format="customFormatter" placeholder="dd/mm/yyyy"/>
              <i class="fa fa-calendar" aria-hidden="true"></i>
              <span v-if="error.date" class="error-msg">{{ error.date }}</span>
            </div>

            <div class="form-group">
              <label>E-mail</label>
              <input v-model="dataLog.email" readonly type="text" class="form-control" name="em" required>
              <span v-if="!dataLog.email" class="error-msg">Caso o email não tenha valor, atualize a pg antes de continuar.</span>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button v-on:click="sendLog()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Enviar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import moment from 'moment'

import {
  SEND_NTF_LOG
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";

export default {
  name: "modalSendUserLog",
  props: ['callCheckRequest'],
  components: {
    datepicker
  },
  data() {
    return {
      ptBR: ptBR,
      error: {
        date: ''
      },
      dataLog: {
        email: '',
        date: ''
      },
      loadingChange: false
    }
  },
  watch: {
    callCheckRequest: function (val) {
      this.dataLog.email = val.dtUser.email;
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    closeModal() {
      $('#modalSendUserLog').modal('toggle');
    },
    sendLog() {
      this.error.date = "";
      if (this.dataLog.date && this.dataLog.email && this.$route.params.context) {
        this.loadingChange = true;

        let urlModal = SEND_NTF_LOG + "?contextCode=" + this.$route.params.context;
        urlModal += "&email=" + this.dataLog.email;
        urlModal += "&date=" + moment(this.dataLog.date).format("YYYY-MM-DD");

        UTIL_SERVICE.console("DATA SEND:", this.dataLog);
        REQUEST_SERVICE.requestContext('GET', urlModal, this.context).then((response) => {
          UTIL_SERVICE.console("RESULT SEND_NTF_LOG:", response);

          this.loadingChange = false;
          $('#modalSendUserLog').modal('toggle');

          ALERT_SERVICE.swal("Aviso", "Notificação de log enviado com sucesso.", "success");
        }).catch((reason) => {
          this.loadingChange = false;
          $('#modalSendUserLog').modal('toggle');

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      } else {
        if (!this.dataLog.date)
          this.error.date = "Preencha um motivo.";
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#modalSendUserLog {

  .select-date {
    width: 100%;
    margin-top: 20px;

    p {
      font-size: 18px;
      padding-left: 1px;
    }

    .vdp-datepicker {
      display: inline-block;
      width: 100%;

      input {
        border: 1px solid #999;
        border-radius: 5px;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    i {
      display: inline-block;
      position: relative;
      right: 15px;
      top: -23px;
      float: right;
      color: #111;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .text-inf {
    font-size: 15px;
    line-height: 24px;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalSendUserLog.vue